import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { empty, Observable, throwError } from 'rxjs';

import {
  ACHTransaction, BaseResponse, CCTransaction, IACHTransaction, IInvoiceInquiry,
  IInvoicePayment,
  InvoicePay, IPaymentComment, PaymentComment,
  TestTracker
} from '../models';
import { UserService } from './user.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  ccActionUrl: string = '';
  ccRequestId: string = '';
  ccTrackerId: string = '';
  browserName: string = '';
  selectedInvoiceForPayment: IInvoiceInquiry[];
  //selectedInvoiceForPayment: IInvoiceInquiry[];
  overOrUnderPaymentText: string = "You are paying a different amount than due amount";
  overOrUnderPaymentMsgType: string = 'overOrUnderPaymentMsgType';
  constructor(private httpClient: HttpClient,
    private userService: UserService) {
    if (!this.selectedInvoiceForPayment) {
      this.selectedInvoiceForPayment = [];
    }
  }
  resetPaymentList() {
    this.selectedInvoiceForPayment = [];
  }
  removeInvoiceFromPaymentList(dataItem: IInvoiceInquiry) {
    if (this.selectedInvoiceForPayment) {
      this.selectedInvoiceForPayment = this.selectedInvoiceForPayment.filter(x => x.invoiceNumber != dataItem.invoiceNumber);
    }
  }
  addInvoiceForPayment(dataItem: IInvoiceInquiry) {
    var temp = dataItem;//Object.assign({}, dataItem);
    if (!this.selectedInvoiceForPayment) {
      this.selectedInvoiceForPayment = [];
    }
    temp.paymentComments = [];
    var c: PaymentComment;
    this.calculateDiscountForTheCustomer(temp);
    if (temp.isDiscountApplicable) {
      c = new PaymentComment();
      c.isError = false;
      c.message = 'You are getting $' + temp.discountAvailable + ' discount by paying today';
      temp.paymentComments.push(c);
    }
    this.selectedInvoiceForPayment = this.selectedInvoiceForPayment.filter(x => x.invoiceNumber != temp.invoiceNumber);
    this.selectedInvoiceForPayment.push(temp);
  }

  calculateDiscount(dataItem: IInvoiceInquiry, discountPercent) {
    //calculate amount due based on discount

  }

  calculateDiscountForTheCustomer(invoice: IInvoiceInquiry) {
    /*
     *new property needed
     * calculatedAmountDue, discountAvailable, payAmount, paymentReason
     * */
    //if customer paymnet term is D15 and paying within 15 days then the customer is eligible for discount of 1%
    var paymentTerms = this.userService.readUserObject.paymentTerms;

    invoice.paymentReasonRequired = false;
    invoice.calculatedAmountDue = Number(invoice.amountDue);
    invoice.payAmount = Number(invoice.amountDue);
    invoice.paymentReasonCharCounter = '0/200';
    if (invoice.type === 'RM') return;
    if (paymentTerms && paymentTerms === 'D15') {
      var dt = invoice.invoiceDateAsDate;
      var calculatedDueDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 15);
      var today = new Date();
      var curDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      console.log('D15 Check');
      console.log(calculatedDueDate);
      console.log(new Date());
      console.log(curDate);
      if (calculatedDueDate >= curDate) {
        invoice.isDiscountApplicable = true;
        invoice.discountAvailable = +((Number(invoice.amountDue) * 0.01).toFixed(2));
        invoice.calculatedAmountDue = +((Number(invoice.amountDue) - invoice.discountAvailable).toFixed(2));
        invoice.paymentReasonRequired = true;
        invoice.paymentReason = 'Discounted 1%';
        invoice.payAmount = Number(invoice.calculatedAmountDue);
        invoice.paymentReasonCharCounter = '13/200';
      }
    } else if (paymentTerms && paymentTerms === 'N07') {
      var invoiceDate = invoice.invoiceDateAsDate;
      var today = new Date();
      var curDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      console.log('N07 Check');
      console.log(new Date());
      console.log(curDate);
      var isDiscApplicable = false;
      if (invoiceDate.getDate() < 16) {
        var dicountDueDate = new Date(invoiceDate.getFullYear(), invoiceDate.getMonth(), 26);//   max due date is 26
        if (curDate < dicountDueDate) {
          isDiscApplicable = true;
        }
      }
      else if (invoiceDate.getDate() >= 16) {
        var dicountDueDate2 = new Date(invoiceDate.getFullYear(), (invoiceDate.getMonth() + 1));// advancing 1 month
        dicountDueDate2 = new Date(dicountDueDate2.getFullYear(), dicountDueDate2.getMonth(), 11); // max due date is 11th with advance 1 month 
        if (curDate < dicountDueDate2) {
          isDiscApplicable = true;
        }
      }
      if (isDiscApplicable) {
        invoice.isDiscountApplicable = true;
        invoice.discountAvailable = +((Number(invoice.amountDue) * 0.02).toFixed(2));
        invoice.calculatedAmountDue = +((Number(invoice.amountDue) - invoice.discountAvailable).toFixed(2));
        invoice.paymentReasonRequired = true;
        invoice.paymentReason = 'Discounted 2%';
        invoice.payAmount = Number(invoice.calculatedAmountDue);
        invoice.paymentReasonCharCounter = '13/200';
      }
    }
    else if (paymentTerms && paymentTerms === 'N10') {
      var dt = invoice.invoiceDateAsDate;
      var calculatedDueDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 15);
      var today = new Date();
      var curDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      console.log('N10 Check');
      console.log(calculatedDueDate);
      console.log(new Date());
      console.log(curDate);
      if (calculatedDueDate >= curDate) {
        invoice.isDiscountApplicable = true;
        invoice.discountAvailable = +((Number(invoice.amountDue) * 0.015).toFixed(2));
        invoice.calculatedAmountDue = +((Number(invoice.amountDue) - invoice.discountAvailable).toFixed(2));
        invoice.paymentReasonRequired = true;
        invoice.paymentReason = 'Discounted 1.5%';
        invoice.payAmount = Number(invoice.calculatedAmountDue);
        invoice.paymentReasonCharCounter = '13/200';
      }
    }
  }


  getIfCustomerCanMakePayment() {
    //check roles of the user and see if he has permission to make payment
    return true;//

  }

  cancelLastTransaction(trackerId: string) {
    //save details in the backend
    var custNum = this.userService.readUserObject.customerNumber;
    var data = {
      "trackerId": trackerId,
      "customerNumber": custNum
    };
    //redirect to PNC
    const apiEndpointFileUpload = "/InvoicePayment/CancelACHPayment";//initiate ACH Payment
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }

  completeLastTransaction(trackerId: string, confirmatioNumber: string) {
    //save details in the backend
    var custNum = this.userService.readUserObject.customerNumber;
    var data = {
      "trackerId": trackerId,
      "customerNumber": custNum,
      "confirmationNumber": confirmatioNumber
    };
    //redirect to PNC
    const apiEndpointFileUpload = "/InvoicePayment/Complete";//initiate ACH Payment
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }



  initiateACHPayment() {
    //save details in the backend    

    var data: ACHTransaction = new ACHTransaction();
    var u = this.userService.readUserObject;
    data.userName = u.userName;
    data.email = u.userEmail;
    data.customerNumber = Number(u.customerNumber);
    data.fullName = u.userFirstName + ' ' + u.userLastName;
    data.customerName = u.customerName;
    data.invoices = [];
    var item: InvoicePay;
    //push the invoices here
    this.selectedInvoiceForPayment.forEach((inv, index) => {
      item = new InvoicePay();
      item.invoiceNumber = inv.invoiceNumber;
      item.amountDue = Number(inv.amountDue) || 0;
      //item.calculatedAmountDue = inv.calculatedAmountDue;
      item.amountPaid = inv.payAmount || 0;
      item.discountAvailable = inv.discountAvailable || 0;
      item.finalAmountDue = item.amountDue - item.discountAvailable;
      item.originalAmount = Number(inv.originalAmount) || 0;
      item.invoiceDate = inv.invoiceDateAsDate;
      item.dueDate = inv.dueDateAsDate;
      item.type = inv.type;
      item.poNumber = inv.poNumber;
      item.jobName = inv.jobName;
      item.paymentReason = inv.paymentReason || '';
      //1->honored, 2->taken by user, 3->NA
      item.discountStatus = 3;
      item.discountTaken = item.amountDue - item.amountPaid;
      if (inv.discountAvailable > 0) {
        item.discountStatus = 2;
        item.discountTaken = item.amountDue - item.amountPaid;
        item.discountComment = "Customer is paying a different amount than due amount(" + item.finalAmountDue + "). Please see the reason.";
        if (inv.paymentComments && inv.paymentComments.length > 0) {
          var t = inv.paymentComments.filter(x => x.message.indexOf("You are getting") > -1);
          if (t && t.length > 0) {
            item.discountStatus = 1;
            item.discountComment = "Customer is getting $" + item.discountAvailable + " discount";
          }
        }
      }
      data.invoices.push(item);
    })

    //console.log(data);
    //throw new Error('Only Test!');
    //redirect to PNC
    const apiEndpointFileUpload = "/InvoicePayment/InitiateACHPayment";//initiate ACH Payment
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  initiateCreditCardPayment() {
    //save details in the backend    

    var data: CCTransaction = new CCTransaction();
    var u = this.userService.readUserObject;
    data.userName = u.userName;
    data.email = u.userEmail;
    data.customerNumber = Number(u.customerNumber);
    data.fullName = u.userFirstName + ' ' + u.userLastName;
    data.customerName = u.customerName;
    data.browserName = this.browserName;
    data.invoices = [];
    var item: InvoicePay;
    //push the invoices here
    this.selectedInvoiceForPayment.forEach((inv, index) => {
      item = new InvoicePay();
      item.invoiceNumber = inv.invoiceNumber;
      item.amountDue = Number(inv.amountDue) || 0;
      //item.calculatedAmountDue = inv.calculatedAmountDue;
      item.amountPaid = inv.payAmount || 0;
      item.discountAvailable = inv.discountAvailable || 0;
      item.finalAmountDue = item.amountDue - item.discountAvailable;
      item.originalAmount = Number(inv.originalAmount) || 0;
      item.invoiceDate = inv.invoiceDateAsDate;
      item.dueDate = inv.dueDateAsDate;
      item.type = inv.type;
      item.poNumber = inv.poNumber;
      item.jobName = inv.jobName;
      item.paymentReason = inv.paymentReason || '';
      //1->honored, 2->taken by user, 3->NA
      item.discountStatus = 3;
      item.discountTaken = item.amountDue - item.amountPaid;
      if (inv.discountAvailable > 0) {
        item.discountStatus = 2;
        item.discountTaken = item.amountDue - item.amountPaid;
        item.discountComment = "Customer is paying a different amount than due amount(" + item.finalAmountDue + "). Please see the reason.";
        if (inv.paymentComments && inv.paymentComments.length > 0) {
          var t = inv.paymentComments.filter(x => x.message.indexOf("You are getting") > -1);
          if (t && t.length > 0) {
            item.discountStatus = 1;
            item.discountComment = "Customer is getting $" + item.discountAvailable + " discount";
          }
        }
      }
      data.invoices.push(item);
    })

    //redirect to PNC
    const apiEndpointFileUpload = "/InvoicePayment/InitiateCreditCardPayment";//initiate CC Payment
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  completeCreditCardPayment(data: any) {
    //save details in the backend    
    const apiEndpointFileUpload = "/InvoicePayment/CreditCardCompleteTransaction";
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  cancelCreditCardPayment(data: any) {
    //save details in the backend    
    const apiEndpointFileUpload = "/InvoicePayment/CreditCardCancelTransaction";
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  redirectToPNC(payload: any, actionUrl) {
    let f = document.createElement("form");
    f.setAttribute("method", "post");
    f.setAttribute(
      "action",
      actionUrl
    ); //Your action URL
    var config = [];

    config.push({ "name": "Name", "value": payload.Name });
    config.push({ "name": "AccountNumber", "value": payload.AccountNumber });
    config.push({ "name": "InvoiceNumber", "value": payload.InvoiceNumber });
    config.push({ "name": "AmountDue", "value": payload.AmountDue });
    config.push({ "name": "Email", "value": payload.Email });
    config.push({ "name": "ClientID", "value": payload.ClientID });
    config.push({ "name": "ID", "value": payload.ID });
    config.push({ "name": "trackerID", "value": payload.trackerID });

    //var tarckObj = this.getTrackerObject(payload.trackerID);
    //this.saveTrackerInLocalStorage(tarckObj);

    //create hidden input elements
    config.forEach((item) => {
      let i = document.createElement("input");
      i.type = "hidden";
      i.name = item.name;
      i.value = item.value;
      f.appendChild(i); //Add it to the form
    });

    document.body.appendChild(f);//Add the form to the body
    f.submit(); //Submit it immediately
  }

  redirectToCC(payload: any, actionUrl) {
    let f = document.createElement("form");
    f.setAttribute("method", "post");
    f.setAttribute(
      "action",
      actionUrl
    ); //Your action URL
    var config = [];

    //create hidden input elements
    config.forEach((item) => {
      let i = document.createElement("input");
      i.type = "hidden";
      i.name = item.name;
      i.value = item.value;
      f.appendChild(i); //Add it to the form
    });

    document.body.appendChild(f);//Add the form to the body
    f.submit(); //Submit it immediately
  }
  //#region Test Data
  fillTestInvoices() {
    var data = [
      { "invoiceNumber": 193489, "orderBu": "00057", "orderNumber": "4101822", "invoiceDate": "121277", "invoiceDateUIString": "10/04/2021", "type": "RI", "poNumber": "21739", "jobName": "BLUME", "originalAmount": 1183.39, "amountDue": 1000, "checkNumber": 0, "marketSegment": "Retail & Stores", "billTo": "82512", "grossAmount": 1183.39, "openAmount": 0, "taxableAmount": 0, "tax": 0, "nonTaxableAmount": 1183.39, "kdReferenceNumber": "", "orderType": "SO", "paymentStatus": "PAID" },
      { "invoiceNumber": 193489, "orderBu": "00057", "orderNumber": "4101822", "invoiceDate": "121277", "invoiceDateUIString": "10/04/2021", "type": "RI", "poNumber": "21739", "jobName": "BLUME", "originalAmount": -1183.39, "amountDue": 0, "checkNumber": 55144, "marketSegment": "Retail & Stores", "billTo": "82512", "grossAmount": -1183.39, "openAmount": 0, "taxableAmount": 0, "tax": 0, "nonTaxableAmount": 0, "kdReferenceNumber": "", "orderType": "SO", "paymentStatus": "PAID" },
      { "invoiceNumber": 193491, "orderBu": "00057", "orderNumber": "4117804", "invoiceDate": "121277", "invoiceDateUIString": "10/04/2021", "type": "RI", "poNumber": "21920", "jobName": "SIMON SUPERMARKET REPL", "originalAmount": 74.66, "amountDue": 70, "checkNumber": 0, "marketSegment": "Retail & Stores", "billTo": "82512", "grossAmount": 74.66, "openAmount": 0, "taxableAmount": 0, "tax": 0, "nonTaxableAmount": 74.66, "kdReferenceNumber": "192047", "orderType": "SO", "paymentStatus": "PAID" },]
    // this.selectedInvoiceForPayment = data;
  }
  //#endregion


  fetchOpenInvoices() {
    //save details in the backend
    var custNum = this.userService.readUserObject.customerNumber;
    //var data = {
    //  "customerNumber": custNum
    //};
    //redirect to PNC
    const apiEndpointFileUpload = "/InvoicePayment/FetchOpenInvoices/" + custNum;//initiate ACH Payment
    return ApiService.genericObservableGet(this.httpClient, apiEndpointFileUpload).pipe(
      catchError((err, caught) => { throw err; }),
      map((items: BaseResponse) => items.data.map((item: IInvoiceInquiry) =>
      ({
        invoiceNumber: item.invoiceNumber, invoiceDate: item.invoiceDate, invoiceDateUIString: item.invoiceDateUIString, invoiceDateAsDate: new Date(item.invoiceDateUIString),
        type: item.type, jobName: item.jobName, originalAmount: item.originalAmount, amountDue: item.amountDue, checkNumber: item.checkNumber,
        marketSegment: item.marketSegment, invoiceStatus: item.invoiceStatus, billTo: item.billTo, orderBu: item.orderBu,
        orderNumber: item.orderNumber, shipTo: item.shipTo, poNumber: item.poNumber, grossAmount: item.grossAmount, openAmount: item.openAmount, taxableAmount: item.taxableAmount,
        tax: item.tax, nonTaxableAmount: item.nonTaxableAmount, kdReferenceNumber: item.kdReferenceNumber, orderType: item.orderType,
        paymentStatus: item.paymentStatus,
        dueDate: item.dueDate, dueDateUIString: item.dueDateUIString,
        dueDateAsDate: item.dueDateUIString ? new Date(item.dueDateUIString) : null
      } as IInvoiceInquiry))));;
  }


  isPaymentFreezeActive() {
    const apiEndpointFileUpload = "/InvoicePayment/IsMonthlyFreezeActive";
    return ApiService.genericObservableGet(this.httpClient, apiEndpointFileUpload) as Observable<any>;
  }

  //#region test tracker to be deleted
  trackerStorageKey: string = 'tracker'
  getTrackerObject(id: string) {
    var tid: TestTracker = new TestTracker();
    tid.trackerId = id;
    tid.dateGenerated = new Date();
    return tid;
  }
  saveTrackerInLocalStorage(obj: TestTracker) {
    //localStorage.setItem(this.trackerStorageKey, JSON.stringify(obj));
  }
  removeTrackerFromLocalStorage() {
    //localStorage.removeItem(this.trackerStorageKey);
  }
  getSavedTrackerId() {
    var storedObj = localStorage.getItem(this.trackerStorageKey);
    if (!storedObj) return null;
    var obj = JSON.parse(storedObj) as TestTracker;
    if (obj) {
      return obj.trackerId;
    }
    else {
      return null;
    }
  }

  mapLastTransactionDetailsResponse(input: IInvoicePayment[], output: any[]) {
    if (!input || !output) return;
    input.forEach((item, index) => {
      var inv = {
        invoiceNumber: item.invoiceNumber,
        invoiceDateAsDate: item.invoiceDate,
        poNumber: item.poNumber,
        jobName: item.jobName,
        originalAmount: item.originalAmount.toString(),
        amountDue: item.originalAmountDue.toString(),
        calculatedAmountDue: item.finalAmountDue.toString(),
        payAmount: item.amountPaid.toString(),
        paymentReason: item.paymentReason,
        discountAvailable: item.discountAvailable,
        isDiscountApplicable: item.discountAvailable >= 0.1 ? true : false,
        //add payment comments
      };
      output.push(inv)
    })
    return output;
  }


  //#endregion


  //change this to better approach
  addMoney(value1, value2) {
    return value1 + value2;
  }
  substractMoney(value1, value2) {
    return value1 - value2;
  }
  multiplyMoney(value1, value2) {
    return value1 * value2;
  }


  loadCCPrecheck() {
    const apiEndpointFileUpload = "/InvoicePayment/GetCCTransactionSupportData";
    return ApiService.genericObservableGet(this.httpClient, apiEndpointFileUpload);
  }
}
